import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileInput from './FileInput';
import ActionMenu from './ActionMenu';
import FileNameInput from './FileNameInput';

import { Box } from '@wds/box';
import { IconInfoFilled } from '@wds/icons';
import { Popout } from '@wds/popout';
import { Textarea } from 'sma.common/components/ads/textarea/Textarea';

import {
	fileDescription,
	fileUploadSelector,
	fileFieldList,
} from './FileUploadField.style';


/**
 * This is the component that will contain individual files or the button to
 * add more file.
 *
 * The file input and button to add another file is in here since in the end,
 * we need the inputs to contain the file, even if they are not shown.
 *
 * @export
 * @class FileField
 * @extends {Component}
 */
export default class FileField extends Component {

	constructor(props) {
		super(props);

		this.state = {
			id: `${props.id}_${props.index}`,
			showErrorModal: false,
			errors: '',
		};

		this.handleFileInputChange = this.handleFileInputChange.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleInputChange(event) {
		this.props.handleInputChange(this.props.index, event);
	}

	handleFileInputChange(event) {
		if (event.target.files) {
			const { name, size, type } = event.target.files[0];
			const added = this.props.addFileToList(this.props.index, name, size, type);
			this.props.notifyApply(this.props.id, this.props.hasFile);
			if (!added) {
				event.target.value = '';
			}
		}
	}

	render(config) {
		for (const key in config) {
			this.props[key] = config[key];
		}
		return (
			<React.Fragment
				key={this.props.index}
			>
				{
					this.props.hasFile
					&& (
						<li
							style={fileFieldList}
						>
							<div
								style={fileUploadSelector}
							>
								<FileNameInput
									type="text"
									name={`${this.state.id}-name`}
									id={`${this.state.id}-name`}
									fileName={this.props.fileName}
								/>
								<span>
									<ActionMenu
										index={this.props.index}
										fileName={this.props.fileName}
										filePath={this.props.file}
										convertedFilePath={this.props.converted}
										handleFileDelete={this.props.handleFileDelete}
										mediaUrl={this.props.mediaUrl}
									/>
								</span>
								{
									!this.props.file
									&& (
										   <Box element="span" pl={2}>
											   <Popout
												   trigger={
													   <IconInfoFilled
														   color="info"
														   tabIndex={0}
														   aria-describedby={`file-upload-tooltip-${this.state.id}`}
													   />
												   }
												   showOnFocus
											   >
												   <Popout.Body id={`file-upload-tooltip-${this.state.id}`}>
													   {gettext(
														   'This file will not be uploaded until you save or ' +
														   'submit this form.'
													   )}
												   </Popout.Body>
											   </Popout>
										   </Box>
									)
								}
								{
									this.props.includeDescription && this.props.hasFile
									&& (
										<div>
											<div style={fileDescription} className="sma-file-upload-file-description">
												<label
													htmlFor={`${this.state.id}-description`}
												>
													{gettext('Description')}:
												</label>
												<Textarea
													strings={{
														charactersEntered: gettext('Characters Entered: '),
														maximum: gettext('Maximum:'),
													}}
													characterCount
													characterLimit={255}
													name={`${this.state.id}-description`}
													id={`${this.state.id}-description`}
													stretched
													value={this.props.fileDescription}
												/>
											</div>
										</div>
									)
								}
							</div>
						</li>
					)
				}
				{
					this.state.errors
					&& (
						<p className="error">{this.state.errors}</p>
					)
				}
				<FileInput
					id={`${this.state.id}-file`}
					questionId={this.props.id}
					index={this.props.index}
					disabled={this.props.disabled}
					handleFileInputChange={(event) => { this.handleFileInputChange(event); }}
					limitFileFormat={this.props.limitFileFormat}
					fileFormats={this.props.fileFormats}
					hasFile={this.props.hasFile}
					first={this.props.first}
				/>
			</React.Fragment>
		);
	}
}

FileField.propTypes = {
	id: PropTypes.string.isRequired,
	disabled: PropTypes.bool.isRequired,
	fileFormats: PropTypes.string.isRequired,
	limitFileFormat: PropTypes.bool.isRequired,
	includeDescription: PropTypes.bool.isRequired,
	addFileToList: PropTypes.func.isRequired,
	index: PropTypes.number.isRequired,
	mediaUrl: PropTypes.string.isRequired,
	handleFileView: PropTypes.func,
	handleFileDelete: PropTypes.func,
	handleFileDownload: PropTypes.func,
	fileName: PropTypes.string,
	fileDescription: PropTypes.string,
	file: PropTypes.string,
	fileSize: PropTypes.number,
	hasFile: PropTypes.bool,
};
